import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import 'primereact/resources/themes/nova/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { isNumber } from '../utils/validationUtils';

class EditAlternatives extends Component {

    constructor(props) {
        super(props);

        this.state = { alternatives: null, default_kpis: null, newRow: null, currentAlternative: null, currentMatrix: [], errorDialog: [] };
        this.saveAlternative = this.saveAlternative.bind(this);
        this.addNewRow = this.addNewRow.bind(this);
        this.deleteAlternative = this.deleteAlternative.bind(this);
        this.onAlternativeSelect = this.onAlternativeSelect.bind(this);
        this.weightEditor = this.weightEditor.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.showWarning = this.showWarning.bind(this);
    }


    componentDidMount() {
        this.setState({
            alternatives: JSON.parse(this.props.alternatives).alternatives,
            default_kpis: JSON.parse(this.props.alternatives).default_kpis,
        });
    }

    saveAlternative() {
        let alternatives = [...this.state.alternatives];
        if (this.newAlternative)
            alternatives.push(this.state.newRow);
        else
            alternatives[this.findSelectedAlternativeIndex()] = this.state.newRow;

        var errorDialog = this.checkErrorDialog(this.state.newRow);

        if (errorDialog.length) {
            this.setState({ errorDialog: errorDialog });
        }
        else {
            this.setState({ alternatives: alternatives, selectedAlternative: null, newRow: null, displayDialog: false,
                default_kpis: JSON.parse(this.props.alternatives).default_kpis});
        }
        this.showWarning();
    }

    addNewRow() {
        this.newAlternative = true;
        this.setState({ displayDialog: true, newRow: { 'id': '', 'acronym': '', 'name': '', 'description': '', 'kpis': this.state.default_kpis } });
    }

    deleteAlternative() {
        let index = this.findSelectedAlternativeIndex();
        this.setState({
            alternatives: this.state.alternatives.filter((val, i) => i !== index),
            selectedAlternative: null,
            newRow: null,
            displayDialog: false
        });
        this.showWarning();
    }

    closeDialog(){
        this.setState({ displayDialog: false });
    }

    findSelectedAlternativeIndex() {
        return this.state.alternatives.indexOf(this.state.selectedAlternative);
    }

    updateProperty(property, value) {
        let newRow = this.state.newRow;
        newRow[property] = value;
        this.setState({ newRow: newRow });
        console.log(this.state.newRow);
    }

    onAlternativeSelect(e) {
        this.newAlternative = false;
        console.log(e.data);
        this.setState({
            displayDialog: true,
            newRow: Object.assign({}, e.data),
            errorDialog: [],
        });
    }

    onDropdownEditorValueChange(field, props, value) {
        let updatedValues = [...props.value];
        updatedValues[0][props.field] = value;
        this.updateProperty(field, updatedValues);


        setTimeout(function () {
            if (document.querySelector('.p-datatable') !== null) {
                document.querySelector('.p-datatable').click();
            }
        }, 300);
    }

    onTextEditorValueChange(field, props, modifiedRowIndex, modifiedField, value) {
        let updatedValues = [...props.value];
        updatedValues[modifiedRowIndex][modifiedField] = value;
        this.updateProperty(field, updatedValues);
    }

    weightEditor(options) {
        return <InputText type="text" defaultValue={options.value} onChange={(e) => this.onTextEditorValueChange('kpis', options.props, options.rowIndex, options.field, e.target.value)} />;
    }

    checkErrorDialog(current) {
        var errorDialog = [];
        if (!current.acronym) {
            errorDialog.push({ 'error': true, 'message': 'Field acronym is required' });
        }
        if (!current.name) {
            errorDialog.push({ 'error': true, 'message': 'Field name is required' });
        }
        for (const [key, value] of Object.entries(current.kpis)) {
            if (!isNumber(value.value)) {
                errorDialog.push({ 'error': true, 'message': 'KPI ' + key + ' value is not a decimal number' });
            }
        }
        return errorDialog;
    }

    /**
     * Show warning message.
     */
    showWarning() {
        this.toast.state = [];
        this.toast.show({severity: 'warn', summary: 'Warning', detail: 'Please, save structure.', sticky: true });
    }

    render() {

        let footer = <div className="clearfix" style={{ width: '100%' }}>
            <div>
                {this.state.alternatives &&
                    <Button label="Add" icon="pi pi-check" onClick={this.addNewRow} />
                }
            </div>
        </div>;

        let dialogFooter = <div className="ui-dialog-buttonpane clearfix">
            <Button icon="pi pi-angle-left" label="Back" onClick={this.closeDialog} />
            <Button icon="pi pi-times" label="Delete" onClick={this.deleteAlternative} />
            <Button icon="pi pi-check" label="Save" onClick={this.saveAlternative} />
            <div className="clearfix"></div>
            <small id="save-help" className="p-d-block">Press the Save button once finished.</small>
        </div>;

        let messageDialog = <div>
            {this.state.errorDialog.length > 0 &&
                this.state.errorDialog.map((col, i) => {
                    return <div key={i} className="py-2"><Message severity="error" text={col.message} /></div>
                })
            }
        </div>


        return (
            <div>
                <Toast ref={(el) => this.toast = el} position="top-right"></Toast>
                <div className="content-section implementation">
                    {this.state.alternatives &&
                        <DataTable value={this.state.alternatives} paginator={true} rows={10} footer={footer}
                            selectionMode="single" selection={this.state.selectedAlternative} onSelectionChange={(e) => { this.setState({ selectedAlternative: e.data }); }}
                            onRowSelect={this.onAlternativeSelect}>
                            <Column field="acronym" header="Acronym" />
                            <Column field="name" header="Name" />
                            <Column field="description" header="Description" />
                        </DataTable>

                    }
                    {this.state.alternatives &&
                        <input name='struct_alternatives' type="hidden" value={JSON.stringify(this.state.alternatives)} />
                    }

                    <Dialog visible={this.state.displayDialog} header="Alternative details" modal={true} footer={dialogFooter} onHide={() => this.setState({ displayDialog: false })}>
                        {this.state.newRow &&
                            <div>
                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="acronym">Acronym</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="acronym" onChange={(e) => { this.updateProperty('acronym', e.target.value) }} value={this.state.newRow.acronym ? this.state.newRow.acronym : ''} />
                                        <small id="acronym-help" className="p-d-block">Provide here an acronym for your planning option.</small>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="name">Name</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="name" onChange={(e) => { this.updateProperty('name', e.target.value) }} value={this.state.newRow.name ? this.state.newRow.name : ''} />
                                        <small id="name-help" className="p-d-block">Provide here a name for your planning option.</small>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="description">Description</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputTextarea rows={5} cols={20} id="description" value={this.state.newRow.description ? this.state.newRow.description : ''} onChange={(e) => { this.updateProperty('description', e.target.value) }} />
                                        <small id="description-help" className="p-d-block">Provide here a description for your planning option.</small>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="kpis">Kpis</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>

                                        <DataTable id="kpis" value={this.state.newRow.kpis} editMode="cell">
                                            <Column key='id' field='id' header='ID' />
                                            <Column key='label' field='label' header='Label' />
                                            <Column key='value' field='value' header='Value' editor={(options) => this.weightEditor(options)} />
                                        </DataTable>
                                        <small id="kpis-label-help" className="p-d-block">Here you can see all the KPIs of your Planning activity.</small>
                                        <div className="clearfix"></div>
                                        <small id="kpis-table-help" className="p-d-block">Considering only the KPIs evaluated with quantitative attributes, press on the corresponding value cell and provide the corresponding attribute value of your planning option.</small>
                                        {messageDialog}
                                    </div>
                                </div>
                            </div>
                        }
                    </Dialog>
                </div>

            </div>
        );
    }
}



export default EditAlternatives;